// 메모 "생성" 중 작성 내용을 임시 저장/복원하는 순수 헬퍼.
// 기밀(메모 본문)이므로 localStorage 가 아니라 sessionStorage 에 둔다 — 탭을 닫으면
// 자동 소멸해 평문 노출 창을 최소화한다. 로그아웃 시에는 landing.logout() 이
// clearMemoDraft() 를 호출해 같은 탭 재로그인 시 남의 초안이 남지 않게 한다.
// (BlockNote ESM 은 jest 파싱이 어려워 컴포넌트 테스트가 힘드므로, 로직을 의존성 zero
//  순수함수로 분리해 여기서 확실히 커버한다.)

const MEMO_DRAFT_KEY = 'safebox.memoDraft'

// 빈 에디터 초기 상태("빈 문단 블록 1개")이면서 제목도 비었는지 판별.
// CreateMemoModal 의 생성 dirty 판정과 동일한 규칙 — 빈 메모는 초안으로 저장하지 않아
// 복원 팝업이 불필요하게 뜨는 것을 막는다.
export const isMemoDraftEmpty = ({ title = '', blocks = [] } = {}) => {
  if (title.trim() !== '') return false
  if (blocks.length > 1) return false
  const block = blocks[0]
  if (block == null) return true
  if (block.type !== 'paragraph') return false
  return (block.content || []).length === 0
}

export const clearMemoDraft = () => {
  window.sessionStorage.removeItem(MEMO_DRAFT_KEY)
}

// 빈 메모면 저장하지 않고 기존 초안까지 제거한다(내용을 지운 뒤 복원 팝업이 뜨지 않게).
// 실제로 저장했으면 true — 호출부가 "임시저장되었습니다" 안내 표시에 사용한다.
// setItem 은 quota 초과 등으로 throw 할 수 있고 이 함수는 디바운스 타이머 안에서
// 불리므로(전역 에러 표시 없음) 실패를 삼키고 false 를 반환한다.
export const saveMemoDraft = ({ title = '', blocks = [] } = {}) => {
  if (isMemoDraftEmpty({ title, blocks })) {
    clearMemoDraft()
    return false
  }
  try {
    const payload = JSON.stringify({ title, blocks, savedAt: Date.now() })
    window.sessionStorage.setItem(MEMO_DRAFT_KEY, payload)
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

// 저장된 초안을 반환하고, 없거나 손상됐으면 null. 절대 throw 하지 않는다.
export const loadMemoDraft = () => {
  const raw = window.sessionStorage.getItem(MEMO_DRAFT_KEY)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw)
    if (parsed == null || typeof parsed !== 'object' || !Array.isArray(parsed.blocks)) {
      return null
    }
    return parsed
  } catch {
    return null
  }
}
